import type { SVGProps } from 'react';
const SvgCursor = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#CC1B17"
      strokeLinecap="square"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M6.75 10.875v3"
    />
    <path fill="#fff" d="M10.125 11.25V9.937a1.687 1.687 0 1 1 3.375 0v1.313" />
    <path
      stroke="#CC1B17"
      strokeLinecap="square"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M10.125 11.25V9.937a1.687 1.687 0 1 1 3.375 0v1.313"
    />
    <path fill="#fff" d="M13.5 10.688a1.687 1.687 0 1 1 3.375 0v.937" />
    <path
      stroke="#CC1B17"
      strokeLinecap="square"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M13.5 10.688a1.687 1.687 0 1 1 3.375 0v.937"
    />
    <path
      fill="#fff"
      d="M16.875 11.625s.047-1.5 1.5-1.5c.867 0 1.5.516 1.5 1.5 0 5.906-2.25 11.25-2.25 11.25H6.375c0-1.922-2.625-3.625-2.625-6v-4.5a1.5 1.5 0 0 1 1.5-1.5h1.5V2.437a1.688 1.688 0 0 1 3.375 0v8.438"
    />
    <path
      stroke="#CC1B17"
      strokeLinecap="square"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M16.875 11.625s.047-1.5 1.5-1.5c.867 0 1.5.516 1.5 1.5 0 5.906-2.25 11.25-2.25 11.25H6.375c0-1.922-2.625-3.625-2.625-6v-4.5a1.5 1.5 0 0 1 1.5-1.5h1.5V2.437a1.688 1.688 0 0 1 3.375 0v8.438"
    />
  </svg>
);
export default SvgCursor;
